import {
  GETSTREAM_APP_ID_DEV,
  GETSTREAM_APP_ID_PROD,
  GETSTREAM_BETA_ORG_ID,
  GETSTREAM_BETA_APP_ID_DEV,
  GETSTREAM_BETA_APP_ID_PROD,
  FASTRELAY_APP_ID_DEV,
  FASTRELAY_APP_ID_PROD
} from '../../app/config';

/**
 * Determines the appropriate GetStream app ID based on the current environment
 * @param env The current environment ('dev' or 'prod')
 * @returns The GetStream app ID for the environment
 */
export const getStreamAppId = (env: string): string => {
  return env === 'dev' ? GETSTREAM_APP_ID_DEV : GETSTREAM_APP_ID_PROD;
};

/**
 * Determines the appropriate GetStream beta app ID based on the current environment
 * @param env The current environment ('dev' or 'prod')
 * @returns The GetStream beta app ID for the environment
 */
export const getStreamBetaAppId = (env: string): string => {
  return env === 'dev' ? GETSTREAM_BETA_APP_ID_DEV : GETSTREAM_BETA_APP_ID_PROD;
};

/**
 * Resolves the GetStream dashboard URL with the appropriate app ID based on environment
 * @param path The path to append after the app ID
 * @param env The current environment ('dev' or 'prod')
 * @returns The complete GetStream dashboard URL
 */
export const getStreamDashboardUrl = (path: string, env: string): string => {
  const appId = getStreamAppId(env);
  return `https://dashboard.getstream.io/app/${appId}${path}`;
};

/**
 * Resolves the GetStream beta dashboard URL with the appropriate organization and app ID based on environment
 * @param path The path to append after the app ID (e.g., '/feeds/explorer/community:abc123')
 * @param env The current environment ('dev' or 'prod')
 * @returns The complete GetStream beta dashboard URL
 */
export const getStreamBetaDashboardUrl = (path: string, env: string): string => {
  const appId = getStreamBetaAppId(env);
  return `https://beta.dashboard.getstream.io/organization/${GETSTREAM_BETA_ORG_ID}/${appId}${path}`;
};

/**
 * Resolves the Fastrelay dashboard feed URL with the appropriate app ID based on environment
 * @param feedId The feed ID in the format 'community:uuid'
 * @param env The current environment ('dev' or 'prod')
 * @returns The complete Fastrelay dashboard feed URL
 */
export const getFastrelayFeedUrl = (feedId: string, env: string): string => {
  const appId = env === 'dev' ? FASTRELAY_APP_ID_DEV : FASTRELAY_APP_ID_PROD;
  return `https://dashboard.fastrelay.io/apps/${appId}/feeds/${encodeURIComponent(feedId)}`;
};
